<template>
    <div class="app-page">
        <Header ref="header" helpURL="studio/apps/">
        <template #page-slot>            
            Apps
        </template>
        </Header>
            <div class="main-page-div">
            <main id="drop-area" class="main-display-area" >
                <router-view />

                <div class="scroll">
                    <Apps 
                        @job_started="handleJobStarted"
                    />
                </div>

        </main>
    </div>
    </div>
</template>

<script setup>

import { useRouter } from 'vue-router';
import Header from '@/components/Header.vue';
import Apps from '@/components/Apps/AppsList.vue';

const router = useRouter();

const handleJobStarted = () => {
    router.push({ name: 'tasks' });
};

</script>

<style lang="scss" scoped>

a {
  text-decoration: none;
    color:#dfe0e0;
}

.scroll {
    overflow: auto;
    width: 100%;
}

</style>
